import React from "react"
import CloseIcon from "@material-ui/icons/Close"
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft"
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight"
import FullscreenIcon from "@material-ui/icons/Fullscreen"
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit"
import GetAppIcon from "@material-ui/icons/GetApp"
import PublishIcon from "@material-ui/icons/Publish"
import PrintIcon from "@material-ui/icons/Print"
import MoreVertIcon from "@material-ui/icons/MoreVert"
import DirectionsIcon from "@material-ui/icons/Directions"
import {
  Label,
  LabelOutlined,
  InfoOutlined,
  FileCopy,
} from "@material-ui/icons"

export const DuplicateIcon = (height = 14) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: top;
      opacity: 0.9;
    `}
    dangerouslySetInnerHTML={{
      __html: `
 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${
   height * 1.75
 }px" height="${height}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512"><path d="M472 16H160a24.027 24.027 0 0 0-24 24v312a24.027 24.027 0 0 0 24 24h312a24.027 24.027 0 0 0 24-24V40a24.027 24.027 0 0 0-24-24zm-8 328H168V48h296z"/><path d="M344 464H48V168h56v-32H40a24.027 24.027 0 0 0-24 24v312a24.027 24.027 0 0 0 24 24h312a24.027 24.027 0 0 0 24-24v-64h-32z"/></svg>`,
    }}
  />
)

export const TrashIcon = (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: top;
    `}
    dangerouslySetInnerHTML={{
      __html: `
 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" height="18px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" /></svg>`,
    }}
  />
)
export const ExpandIcon = (
  <span
    dangerouslySetInnerHTML={{
      __html: `
 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 42 42"><path d="M21.391 16.17l4.439 4.439c1.13 1.131 1.57 1.101 2.67 0l6.67-6.67l5.33 5.34V1.5H22.721l5.34 5.33l-6.67 6.67c-1.08 1.08-1.112 1.561 0 2.67zm-1.782 10.66l-4.439-4.439c-1.13-1.131-1.57-1.101-2.67 0l-6.67 6.67l-5.33-5.34V41.5h17.779l-5.34-5.33l6.67-6.67c1.08-1.08 1.112-1.561 0-2.67z" fil="#626262"/></svg>`,
    }}
  />
)
export const CollapseIcon = (
  <span
    dangerouslySetInnerHTML={{
      __html: `
 <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M4 12h16v2H4v-2m0-3h16v2H4V9m12-5l-4 4l-4-4h3V1h2v3h3M8 19l4-4l4 4h-3v3h-2v-3H8z" fil="#626262"/></svg>`,
    }}
  />
)
export const DownIcon = (dimension = 28) => (
  <span
    css={`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    }
  `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="black" d="M16.59 8.59L12 13.17L7.41 8.59L6 10l6 6l6-6z"/></svg>
      `,
    }}
  />
)
export const UpIcon = (dimension = 28) => (
  <span
    css={`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    }
  `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="black" d="m12 8l-6 6l1.41 1.41L12 10.83l4.59 4.58L18 14z"/></svg>
      `,
    }}
  />
)
export const AddIcon = (dimension = 28) => (
  <span
    css={`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    }
  `}
    dangerouslySetInnerHTML={{
      __html: `
     <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="black" d="M8 11h8v2H8zm12.1 1H22c0-2.76-2.24-5-5-5h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1M19 12h-2v3h-3v2h3v3h2v-3h3v-2h-3z"/></svg>
      `,
    }}
  />
)
export const MoveDownIcon = (dimension = 28) => (
  <span
    css={`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    }
  `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="none" stroke="#535353" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 11v10m-3-3l3 3l3-3M10 5a2 2 0 1 0 4 0a2 2 0 1 0-4 0"/></svg>
      `,
    }}
  />
)
export const MoveUpIcon = (dimension = 28) => (
  <span
    css={`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    }
  `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="none" stroke="#535353" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V3M9 6l3-3l3 3m-3 11a2 2 0 1 1 0 4a2 2 0 0 1 0-4"/></svg>
      `,
    }}
  />
)
export const newFile = (
  <span
    css={`
      width: 17px;
      height: 25px;
      vertical-align: bottom;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1200 1200"><path d="M255.583 0L29.513 218.249V1200H635.49v-104.328H134.506V292.179h197.589v-187.85h442.844v312.986h104.992V0H255.583zm472.725 508.73v249.091H479.145V950.91h249.163V1200h193.016V950.91h249.164V757.821H921.323V508.73H728.308z" /></svg>`,
    }}
  />
)
export const newFolder = (
  <span
    css={`
      width: 17px;
      height: 25px;
      vertical-align: bottom;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-8-4h2v2h2v-2h2v-2h-2v-2h-2v2h-2z" /></svg>`,
    }}
  />
)
export const uploadFile = (
  <span
    css={`
      width: 17px;
      height: 25px;
      vertical-align: bottom;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M14 2l6 6v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8m4 18V9h-5V4H6v16h12m-6-8l4 4h-2.5v3h-3v-3H8l4-4z" /></svg>`,
    }}
  />
)
export const uploadFolder = (
  <span
    css={`
      width: 17px;
    height: 25px;
    vertical-align: bottom;
    cursor:pointer;
}
  `}
    dangerouslySetInnerHTML={{
      __html: `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M20 18H4V8h16m0-2h-8l-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-4 11h-2v-4h-3l4-4l4 4h-3z" /></svg>`,
    }}
  />
)
export const pencil = (
  <span
    css={`
      width: 17px;
      height: 25px;
      vertical-align: bottom;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z" /></svg>`,
    }}
  />
)
export const EditIcon = (dimension = 28) => (
  <span
    css={`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    }
  `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 32 32"><path fill="currentColor" d="M2 26h28v2H2zM25.4 9c.8-.8.8-2 0-2.8l-3.6-3.6c-.8-.8-2-.8-2.8 0l-15 15V24h6.4l15-15zm-5-5L24 7.6l-3 3L17.4 7l3-3zM6 22v-3.6l10-10l3.6 3.6l-10 10H6z"/></svg>
      `,
    }}
  />
)

export const NewWindow = (
  <span
    css={`
      width: 17px;
      height: 25px;
      vertical-align: sub;
      cursor:pointer;
  }
  `}
    dangerouslySetInnerHTML={{
      __html: `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1zM14 4c0 .55.45 1 1 1h2.59l-9.13 9.13a.996.996 0 1 0 1.41 1.41L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1z" fill="#155CB4"/></svg>`,
    }}
  />
)

export const SearchIcon = (
  <span
    css={`
      width: 24px;
    height: 24px;
    vertical-align: bottom;
}
  `}
    dangerouslySetInnerHTML={{
      __html: `
      <?xml version="1.0"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width=24 height=24  xml:space="preserve"><path d="M344.5,298c15-23.6,23.8-51.6,23.8-81.7c0-84.1-68.1-152.3-152.1-152.3C132.1,64,64,132.2,64,216.3  c0,84.1,68.1,152.3,152.1,152.3c30.5,0,58.9-9,82.7-24.4l6.9-4.8L414.3,448l33.7-34.3L339.5,305.1L344.5,298z M301.4,131.2  c22.7,22.7,35.2,52.9,35.2,85c0,32.1-12.5,62.3-35.2,85c-22.7,22.7-52.9,35.2-85,35.2c-32.1,0-62.3-12.5-85-35.2  c-22.7-22.7-35.2-52.9-35.2-85c0-32.1,12.5-62.3,35.2-85c22.7-22.7,52.9-35.2,85-35.2C248.5,96,278.7,108.5,301.4,131.2z"/></svg>`,
    }}
  />
)
export const ForkIcon = (
  <span
    css={`
      width: 24px;
    height: 24px;
    vertical-align: middle;
}
  `}
    dangerouslySetInnerHTML={{
      __html: `
      <?xml version="1.0"?><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 1792 1792" width="24"><path d="M672 1472q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zm0-1152q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zm640 128q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zm96 0q0 52-26 96.5t-70 69.5q-2 287-226 414-68 38-203 81-128 40-169.5 71t-41.5 100v26q44 25 70 69.5t26 96.5q0 80-56 136t-136 56-136-56-56-136q0-52 26-96.5t70-69.5v-820q-44-25-70-69.5t-26-96.5q0-80 56-136t136-56 136 56 56 136q0 52-26 96.5t-70 69.5v497q54-26 154-57 55-17 87.5-29.5t70.5-31 59-39.5 40.5-51 28-69.5 8.5-91.5q-44-25-70-69.5t-26-96.5q0-80 56-136t136-56 136 56 56 136z"/></svg>`,
    }}
  />
)

export const TrashIcon2 = (dimension = 28) => (
  <span
    css={`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    }
  `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="4"><path d="M9 10v34h30V10z"/><path stroke-linecap="round" d="M20 20v13m8-13v13M4 10h40"/><path d="m16 10l3.289-6h9.488L32 10z"/></g></svg>
      `,
    }}
  />
)

export const SaveIcon = (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" xmlns:xlink="http://www.w3.org/1999/xlink" height="24px" version="1.1" viewBox="0 0 18 15" width="18px"><title/><desc/><defs/><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#000000" id="Core" transform="translate(-423.000000, -47.000000)"><g id="check" transform="translate(423.000000, 47.500000)"><path d="M6,10.2 L1.8,6 L0.4,7.4 L6,13 L18,1 L16.6,-0.4 L6,10.2 Z" id="Shape"/></g></g></g></svg>`,
    }}
  />
)

export const SaveIcon2 = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 448 512"><path fill="currentColor" d="m433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941M272 80v80H144V80zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6M224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88s88-39.477 88-88s-39.477-88-88-88m0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40s40 17.944 40 40s-17.944 40-40 40"/></svg>
      `,
    }}
  />
)

export const ShareIcon = (dimension = 28) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="currentColor" d="M18 22q-1.25 0-2.125-.875T15 19q0-.175.025-.363t.075-.337l-7.05-4.1q-.425.375-.95.588T6 15q-1.25 0-2.125-.875T3 12q0-1.25.875-2.125T6 9q.575 0 1.1.213t.95.587l7.05-4.1q-.05-.15-.075-.337T15 5q0-1.25.875-2.125T18 2q1.25 0 2.125.875T21 5q0 1.25-.875 2.125T18 8q-.575 0-1.1-.212t-.95-.588L8.9 11.3q.05.15.075.338T9 12q0 .175-.025.363T8.9 12.7l7.05 4.1q.425-.375.95-.587T18 16q1.25 0 2.125.875T21 19q0 1.25-.875 2.125T18 22m0-16q.425 0 .713-.287T19 5q0-.425-.288-.712T18 4q-.425 0-.712.288T17 5q0 .425.288.713T18 6M6 13q.425 0 .713-.288T7 12q0-.425-.288-.712T6 11q-.425 0-.712.288T5 12q0 .425.288.713T6 13m12 7q.425 0 .713-.288T19 19q0-.425-.288-.712T18 18q-.425 0-.712.288T17 19q0 .425.288.713T18 20m0-1"/></svg>
      `,
    }}
  />
)

export const OneColumnIcon = (dimension = 28) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 20 20"><path fill="currentColor" d="M15 5.75a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 .75-.75Zm0 3a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 .75-.75Zm0 3a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 .75-.75Zm0 3a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 .75-.75Z"/></svg>
      `,
    }}
  />
)

export const TwoColumnIcon = (dimension = 28) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 20 20"><path fill="currentColor" d="M17 5.75a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 .75-.75Zm-8 0A.75.75 0 0 0 8.25 5h-4.5a.75.75 0 0 0 0 1.5h4.5A.75.75 0 0 0 9 5.75Zm8 3a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 .75-.75Zm-8 0A.75.75 0 0 0 8.25 8h-4.5a.75.75 0 0 0 0 1.5h4.5A.75.75 0 0 0 9 8.75Zm8 3a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 .75-.75Zm-8 0a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 .75-.75Zm8 3a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 .75-.75Zm-8 0a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 .75-.75Z"/></svg>
      `,
    }}
  />
)

export const VerticallyExpandIcon = (dimension = 28) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="currentColor" d="M4 20h16v2H4zM4 2h16v2H4zm9 7h3l-4-4l-4 4h3v6H8l4 4l4-4h-3z"/></svg>
      `,
    }}
  />
)

export const VerticallyCollapseIcon = (dimension = 28) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8Zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0Zm-.5 11.707l-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793Z"/></svg>
      `,
    }}
  />
)

export const RightArrowIcon = (dimension = 28) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="currentColor" d="m13.171 12l-4.95-4.95l1.415-1.413L16 12l-6.364 6.364l-1.414-1.415l4.95-4.95Z"/></svg>
      `,
    }}
  />
)

export const CopyIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="black"
    width=${dimension}
    height=${dimension}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
  </svg>`,
    }}
  />
)

export const notificationIcon = (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg fill="#C4C4CD" height="24" viewBox="0 0 512 512" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M470.346 403.26C468.655 400.18 466.169 397.611 463.146 395.82L441.487 382.82C433.033 377.737 426.038 370.553 421.183 361.967C416.327 353.381 413.776 343.684 413.777 333.82V216.66C413.756 182.674 402.73 149.609 382.347 122.414C361.964 95.2185 333.321 75.3562 300.707 65.8C299.296 65.3984 298.054 64.5512 297.165 63.3849C296.277 62.2187 295.79 60.7962 295.777 59.33C295.777 48.899 291.633 38.8953 284.257 31.5195C276.881 24.1437 266.877 20 256.447 20C246.016 20 236.012 24.1437 228.636 31.5195C221.26 38.8953 217.116 48.899 217.116 59.33C217.102 60.7957 216.614 62.2175 215.726 63.3834C214.837 64.5493 213.596 65.397 212.186 65.8C179.572 75.3562 150.929 95.2185 130.546 122.414C110.163 149.609 99.1367 182.674 99.1164 216.66V333.8C99.1173 343.664 96.566 353.361 91.7104 361.947C86.8548 370.533 79.8601 377.717 71.4065 382.8L49.7465 395.8C46.0067 398.033 43.0981 401.426 41.4629 405.463C39.8276 409.501 39.5551 413.961 40.6867 418.168C41.8184 422.374 44.2922 426.096 47.7324 428.767C51.1726 431.439 55.3911 432.915 59.7465 432.97H453.086C456.534 432.888 459.903 431.923 462.871 430.165C465.839 428.408 468.305 425.918 470.034 422.934C471.764 419.95 472.698 416.572 472.747 413.124C472.797 409.676 471.96 406.272 470.317 403.24L470.346 403.26Z" fill="#C4C4CD"/><path d="M222.447 481.12C229.872 486.373 238.414 489.832 247.402 491.225C256.39 492.619 265.579 491.908 274.246 489.15C282.913 486.392 290.822 481.661 297.351 475.329C303.881 468.998 308.853 461.238 311.876 452.66H200.987C205.035 464.132 212.53 474.073 222.447 481.12Z" fill="#C4C4CD"/></svg>`,
    }}
  />
)

export const infoIcon = <InfoOutlined style={{ color: "#000" }} />

export const goToFile = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 16 16"><path fill="black" fill-rule="evenodd" d="m6 5.914l2.06-2.06v-.708L5.915 1l-.707.707l.043.043l.25.25l1 1h-3a2.5 2.5 0 0 0 0 5H4V7h-.5a1.5 1.5 0 1 1 0-3h3L5.207 5.293L5.914 6zM11 2H8.328l-1-1H12l.71.29l3 3L16 5v9l-1 1H6l-1-1V6.5l1 .847V14h9V6h-4zm1 0v3h3z" clip-rule="evenodd"/></svg>`,
    }}
  />
)

export const printIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="currentColor" d="M7 2a1 1 0 0 0-1 1v4H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-2h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2V3a1 1 0 0 0-1-1zm10 12H7a1 1 0 0 0-1 1v2H4V9h16v8h-2v-2a1 1 0 0 0-1-1m-1-7H8V4h8zM5 10v2h3v-2zm11 6v4H8v-4z"/></svg>`,
    }}
  />
)

export const graphIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 32 32"><path fill="black" d="M24 20a4 4 0 1 1 0-8a4 4 0 0 1 0 8m0-6a2 2 0 1 0 0 4a2 2 0 0 0 0-4m-8.2-5.62A4 4 0 1 1 18 1.06a4 4 0 0 1-2.2 7.32m0-6a2 2 0 1 0 .01 0zm.01 29.24a4 4 0 1 1-.083-8a4 4 0 0 1 .083 8m0-6a2 2 0 1 0 .39 0a2 2 0 0 0-.4 0z" class="ouiIcon__fillSecondary"/><path fill="black" d="M18 17v-2h-6.14a4 4 0 0 0-.86-1.64l2.31-3.44l-1.68-1.12l-2.31 3.44A4 4 0 0 0 8 12a4 4 0 1 0 0 8a4 4 0 0 0 1.32-.24l2.31 3.44l1.66-1.12L11 18.64a4 4 0 0 0 .86-1.64zM6 16a2 2 0 1 1 4 0a2 2 0 0 1-4 0"/></svg>`,
    }}
  />
)

export const downloadIcon = (
  <GetAppIcon style={{ color: "#000" }} />
  //   <span
  //     css={`
  //       cursor: pointer;
  //       display: inline-block;
  //       vertical-align: middle;
  //     `}
  //     dangerouslySetInnerHTML={{
  //       __html: `
  //       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" fill="#C4C4CD" height="24" viewBox="0 0 512 512" width="24" xml:space="preserve">

  // <defs>
  // </defs>
  // <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" >
  // 	<path d="M 67.109 36.803 c -1.172 -1.172 -3.07 -1.171 -4.242 0 L 48 51.67 V 3 c 0 -1.657 -1.343 -3 -3 -3 c -1.657 0 -3 1.343 -3 3 v 48.67 L 27.133 36.803 c -1.171 -1.172 -3.071 -1.172 -4.242 0 c -1.172 1.171 -1.172 3.071 0 4.242 L 42.876 61.03 c 0.14 0.141 0.295 0.266 0.461 0.377 c 0.071 0.047 0.148 0.08 0.222 0.121 c 0.097 0.054 0.191 0.112 0.294 0.155 c 0.098 0.04 0.199 0.063 0.3 0.093 c 0.087 0.026 0.17 0.059 0.26 0.077 c 0.194 0.039 0.39 0.059 0.587 0.059 c 0.197 0 0.393 -0.021 0.587 -0.059 c 0.092 -0.018 0.178 -0.053 0.267 -0.079 c 0.098 -0.029 0.197 -0.051 0.292 -0.091 c 0.108 -0.045 0.206 -0.105 0.307 -0.162 c 0.069 -0.039 0.142 -0.069 0.208 -0.113 c 0.167 -0.111 0.322 -0.237 0.463 -0.379 l 19.984 -19.983 C 68.281 39.874 68.281 37.975 67.109 36.803 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
  // 	<path d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 26.412 11.681 9.498 29.067 2.913 c 1.549 -0.587 3.281 0.194 3.868 1.743 s -0.193 3.281 -1.743 3.868 C 16.124 14.231 6 28.89 6 45 c 0 21.505 17.495 39 39 39 s 39 -17.495 39 -39 c 0 -16.11 -10.124 -30.769 -25.191 -36.476 c -1.55 -0.587 -2.33 -2.319 -1.743 -3.868 c 0.586 -1.549 2.317 -2.329 3.868 -1.743 C 78.319 9.499 90 26.412 90 45 C 90 69.813 69.813 90 45 90 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
  // </g>
  // </svg>`,
  //     }}
  //   />
)

export const importIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 256 256"><path fill="currentColor" d="M220 112v96a20 20 0 0 1-20 20H56a20 20 0 0 1-20-20v-96a20 20 0 0 1 20-20h24a12 12 0 0 1 0 24H60v88h136v-88h-20a12 12 0 0 1 0-24h24a20 20 0 0 1 20 20ZM96.49 72.49L116 53v83a12 12 0 0 0 24 0V53l19.51 19.52a12 12 0 1 0 17-17l-40-40a12 12 0 0 0-17 0l-40 40a12 12 0 1 0 17 17Z"/></svg>`,
    }}
  />
)

export const exportIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M11.78 7.159a.75.75 0 0 0-1.06 0l-1.97 1.97V1.75a.75.75 0 0 0-1.5 0v7.379l-1.97-1.97a.75.75 0 0 0-1.06 1.06l3.25 3.25L8 12l.53-.53l3.25-3.25a.75.75 0 0 0 0-1.061M2.5 9.75a.75.75 0 1 0-1.5 0V13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9.75a.75.75 0 0 0-1.5 0V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" clip-rule="evenodd"/></svg>
      `,
    }}
  />
)

export const refreshIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="currentColor" d="M12 20q-3.35 0-5.675-2.325T4 12q0-3.35 2.325-5.675T12 4q1.725 0 3.3.712T18 6.75V4h2v7h-7V9h4.2q-.8-1.4-2.188-2.2T12 6Q9.5 6 7.75 7.75T6 12q0 2.5 1.75 4.25T12 18q1.925 0 3.475-1.1T17.65 14h2.1q-.7 2.65-2.85 4.325T12 20Z"/></svg>`,
    }}
  />
)

export const AIIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 32 32"><path fill="black" d="M17 11h3v10h-3v2h8v-2h-3V11h3V9h-8zm-4-2H9c-1.103 0-2 .897-2 2v12h2v-5h4v5h2V11c0-1.103-.897-2-2-2m-4 7v-5h4v5z"/></svg>`,
    }}
  />
)

export const likeIconUnfilled = (dimension = 28, opacity = 1) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24" style="opacity: ${opacity};"><path fill="currentColor" d="M5 9v12H1V9zm4 12a2 2 0 0 1-2-2V9c0-.55.22-1.05.59-1.41L14.17 1l1.06 1.06c.27.27.44.64.44 1.05l-.03.32L14.69 8H21a2 2 0 0 1 2 2v2c0 .26-.05.5-.14.73l-3.02 7.05C19.54 20.5 18.83 21 18 21zm0-2h9.03L21 12v-2h-8.79l1.13-5.32L9 9.03z"/></svg>`,
    }}
  />
)

export const likeIconFilled = (dimension = 28, opacity = 1) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
     <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24" style="opacity: ${opacity};"><path fill="currentColor" d="M23 10a2 2 0 0 0-2-2h-6.32l.96-4.57c.02-.1.03-.21.03-.32c0-.41-.17-.79-.44-1.06L14.17 1L7.59 7.58C7.22 7.95 7 8.45 7 9v10a2 2 0 0 0 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73zM1 21h4V9H1z"/></svg>`,
    }}
  />
)

export const dislikeIconUnfilled = (dimension = 28, opacity = 1) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24" style="opacity: ${opacity};"><path fill="currentColor" d="M19 15V3h4v12zM15 3a2 2 0 0 1 2 2v10c0 .55-.22 1.05-.59 1.41L9.83 23l-1.06-1.06c-.27-.27-.44-.64-.44-1.06l.03-.31l.95-4.57H3a2 2 0 0 1-2-2v-2c0-.26.05-.5.14-.73l3.02-7.05C4.46 3.5 5.17 3 6 3zm0 2H5.97L3 12v2h8.78l-1.13 5.32L15 14.97z"/></svg>`,
    }}
  />
)

export const dislikeIconFilled = (dimension = 28, opacity = 1) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width="${dimension}" height="${dimension}" viewBox="0 0 24 24" style="opacity: ${opacity};"><path fill="currentColor" d="M19 15h4V3h-4m-4 0H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2a2 2 0 0 0 2 2h6.31l-.95 4.57c-.02.1-.03.2-.03.31c0 .42.17.79.44 1.06L9.83 23l6.58-6.59c.37-.36.59-.86.59-1.41V5a2 2 0 0 0-2-2"/></svg>`,
    }}
  />
)


export const playIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 48 48"><defs><mask id="ipSPlay0"><g fill="none" stroke-linejoin="round" stroke-width="4"><path fill="#fff" stroke="#fff" d="M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4S4 12.954 4 24s8.954 20 20 20Z"/><path fill="#000" stroke="#000" d="M20 24v-6.928l6 3.464L32 24l-6 3.464l-6 3.464z"/></g></mask></defs><path fill="black" d="M0 0h48v48H0z" mask="url(#ipSPlay0)"/></svg>`,
    }}
  />
)

export const helpIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="#D2D2D2" d="M11.95 18q.525 0 .888-.363t.362-.887t-.362-.888t-.888-.362t-.887.363t-.363.887t.363.888t.887.362m-.9-3.85h1.85q0-.825.188-1.3t1.062-1.3q.65-.65 1.025-1.238T15.55 8.9q0-1.4-1.025-2.15T12.1 6q-1.425 0-2.312.75T8.55 8.55l1.65.65q.125-.45.563-.975T12.1 7.7q.8 0 1.2.438t.4.962q0 .5-.3.938t-.75.812q-1.1.975-1.35 1.475t-.25 1.825M12 22q-2.075 0-3.9-.787t-3.175-2.138T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"/></svg>`,
    }}
  />
)

export const moreIcon = <MoreVertIcon style={{ color: "#000" }} />

// export const pinnedIcon = (
//   <Label style={{ color: '#000' }}/>
// )

export const pinnedIcon = (dimension = 28) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 32 32"><path fill="currentColor" d="M28.586 13.314L30 11.9L20 2l-1.314 1.415l1.186 1.186L8.38 14.322l-1.716-1.715L5.25 14l5.657 5.677L2 28.583L3.41 30l8.911-8.909L18 26.748l1.393-1.414l-1.716-1.716l9.724-11.49Z"/></svg>
      `,
    }}
  />
)

export const unpinnedIcon = (dimension = 28) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 32 32"><path fill="currentColor" d="M28.59 13.31L30 11.9L20 2l-1.31 1.42l1.18 1.18l-11.49 9.72l-1.72-1.71L5.25 14l5.66 5.68L2 28.58L3.41 30l8.91-8.91L18 26.75l1.39-1.42l-1.71-1.71l9.72-11.49ZM16.26 22.2L9.8 15.74L21.29 6L26 10.71Z"/></svg>
      `,
    }}
  />
)

export const clearIcon = (dimension = 28) => (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="m8.464 15.535l7.072-7.07m-7.072 0l7.072 7.07"/></svg>
      `,
    }}
  />
)

// export const unpinnedIcon = (
//   <LabelOutlined style={{ color: '#000' }}/>
// )

export const successIcon = (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      
<svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32" width="13px" height="13px"><path d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 22.28125 11.28125 L 15 18.5625 L 10.71875 14.28125 L 9.28125 15.71875 L 14.28125 20.71875 L 15 21.40625 L 15.71875 20.71875 L 23.71875 12.71875 Z"/></svg>`,
    }}
  />
)

export const synchronizeIcon = (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="13px" height="13px">    <path d="M 12 0 L 8 4 L 12 8 L 12 5 C 15.859 5 19 8.14 19 12 C 19 12.88 18.82925 13.720094 18.53125 14.496094 L 20.046875 16.009766 C 20.651875 14.800766 21 13.442 21 12 C 21 7.038 16.963 3 12 3 L 12 0 z M 3.953125 7.9902344 C 3.348125 9.1992344 3 10.558 3 12 C 3 16.962 7.037 21 12 21 L 12 24 L 16 20 L 12 16 L 12 19 C 8.141 19 5 15.86 5 12 C 5 11.12 5.17075 10.279906 5.46875 9.5039062 L 3.953125 7.9902344 z"/></svg>`,
    }}
  />
)

export const closeIcon = (
  <span
    css={`
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width="13px" height="13px" viewBox="0 0 24 24"  fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87"/><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"/></svg>`,
    }}
  />
)

export const CancelIcon = <CloseIcon />

export const ArrowLeftIcon = <KeyboardArrowLeftIcon style={{ color: "#000" }} />

export const ArrowRightIcon = (
  <KeyboardArrowRightIcon style={{ color: "#000" }} />
)

export const FullScreenOn = <FullscreenIcon style={{ color: "#000" }} />

export const FullScreenOff = <FullscreenExitIcon style={{ color: "#000" }} />

export const FileCopyIcon = <FileCopy style={{ color: "#000" }} />

export const DirectionIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="currentColor" d="M12 3.515L3.515 12L12 20.485L20.485 12L12 3.515Zm.707-2.122l9.9 9.9a1 1 0 0 1 0 1.414l-9.9 9.9a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l9.9-9.9a1 1 0 0 1 1.414 0ZM13 10V7.5l3.5 3.5l-3.5 3.5V12h-3v3H8v-4a1 1 0 0 1 1-1h4Z"/></svg>`,
    }}
  />
)

export const LoginIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="currentColor" d="M12 21v-2h7V5h-7V3h7q.825 0 1.413.588T21 5v14q0 .825-.588 1.413T19 21h-7Zm-2-4l-1.375-1.45l2.55-2.55H3v-2h8.175l-2.55-2.55L10 7l5 5l-5 5Z"/></svg>`,
    }}
  />
)

export const LogoutIcon = (dimension = 28) => (
  <span
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    `}
    dangerouslySetInnerHTML={{
      __html: `
      <svg xmlns="http://www.w3.org/2000/svg" width=${dimension} height=${dimension} viewBox="0 0 24 24"><path fill="currentColor" d="M5 21q-.825 0-1.413-.588T3 19V5q0-.825.588-1.413T5 3h7v2H5v14h7v2H5Zm11-4l-1.375-1.45l2.55-2.55H9v-2h8.175l-2.55-2.55L16 7l5 5l-5 5Z"/></svg>`,
    }}
  />
)
